import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";

export default {
  name: "Manpower",
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    SelectFromList: require("@/components/selectFromList/selectFromList.vue")
      .default,
  },
  props: ["dataObj"],
  data: function () {
    return {
      manpower: {
        additionalCost: 0,
        allowance: "",
        allowanceId: 0,
        comment: "",
        dt: moment(new Date()).format(),
        employee: "",
        employeeId: 0,
        id: 0,
        isAllowance: false,
        rateHr: 0,
        rateType: "",
        rateTypeId: 0,
        totalCost: 0,
        travelDuration: 0,
        workDuration: 0,
      },
      employee: {
        displayString: "",
        employeeId: 0,
        employeeName: "",
        orgPost: 0,
        orgPostName: "",
        rateHours: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        station: 0,
        stationName: "",
        teamId: -1,
      },
      rateTypes: [],
      employeesAll: [],
      allowances: [],
      allTeams: [],
      team: { text: "", value: "" },
      teamId: -1,
      stations: [],
      station: { text: "", value: "" },
      stationId: -1,
      selection: [],
      rateKey: 0,
      isMultiple: false,
    };
  },
  validations: {
    employee: {
      required,
    },
    allowance: {
      required,
    },
    rateType: {
      required,
    },
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    teams: function () {
      if (this.station.value == -1)
        //all option
        return this.allTeams;
      else {
        let temp = this.allTeams.filter(
          (t) =>
            t.group != null && t.group != "" && t.group.id == this.station.value
        );
        if (temp && temp.length > 0) {
          temp.unshift(this.allTeams[0]);
        } else {
          if (!this.allTeams || this.allTeams.length == 0) {
            this.allTeams = [
              {
                value: -1,
                description: null,
                regularExpression: null,
                text: "All",
                selected: true,
              },
            ];
          }

          temp = this.allTeams;
          this.team = temp[0];
        }

        return temp;
      }
    },
    employees: function () {
      let employees = [...this.employeesAll];

      if (this.station.value > -1)
        employees = employees.filter((p) => p.station == this.station.value);

      if (this.team.value > -1)
        employees = employees.filter((p) => p.teamId == this.team.value);

      return employees;
    },
  },
  watch: {
    station: function (value) {
      if (!value) return;

      this.stationId = parseInt(value.value);

      this.resetDropDowns();
    },
    team: function (value) {
      if (!value) return;

      this.teamId = parseInt(value.value);

      this.resetDropDowns("team");
    },
    "manpower.rateTypeId": function (value) {
      if (!value) return;

      if (value < 1) this.manpower.rateTypeId = 1;

      this.calculateCost(this.isMultiple);
    },
    selectionCount: function (value) {
      //console.log("sel", this.selection, "empl", this.employee,"jjdj", value);

      this.dataObj.selection = [];
      if (value === 0) return;

      this.rateKey++;
      //console.log("selection", this.selection);
      this.calculateCost(this.isMultiple);
    },
    employee: function (value) {
      //console.log("employee watch", this.employee);
      if (!value) return;

      //this.selection = [];

      if (value.employeeId) this.selection = [value];

      this.calculateCost(this.isMultiple);
    },
  },
  created() {
    this.init();
    //console.log("selection", this.selection);
    //console.log("employee", this.employee);
  },
  methods: {
    init() {
      //console.log("data in edit manpower", this.dataObj);
      Vue.nextTick(() => {
        this.isMultiple =
          this.dataObj.isMultiple == null ? true : this.dataObj.isMultiple;
        this.manpower = this.dataObj;
        this.rateTypes = this.dataObj.rateTypes;
        //this.dataObj.employees.forEach(p => p.rate = 0);
        //this.employees = this.dataObj.employees;

        //TBI chenage filters
        this.employeesAll = this.dataObj.employees.filter(
          (e) => e.availableForWork
        );

        this.employeesAll.forEach(
          (e) =>
            (e["employeeDisplay"] = `${e.displayString} / ${e.orgPostName}`)
        );

        this.allowances = this.dataObj.allowances;

        this.allTeams = this.dataObj.teams;
        this.stations = this.dataObj.stations;

        this.manpower.rateTypeId =
          this.dataObj.rateTypeId == null || this.dataObj.rateTypeId < 1
            ? this.dataObj.rateTypes != null
              ? this.dataObj.rateTypes[0].value
              : ""
            : this.dataObj.rateTypeId;
        this.manpower.rateType =
          this.dataObj.rateType == null || this.dataObj.rateType == ""
            ? this.dataObj.rateTypes != null
              ? this.dataObj.rateTypes[0].text
              : ""
            : this.dataObj.rateType;

        let stationList;

        //add default value to station
        if (this.dataObj.applicationStationId >= -1) {
          stationList = this.stations.filter(
            (s) => s.value == this.dataObj.applicationStationId
          );
          if (stationList && stationList.length > 0) {
            this.station = stationList[0];
            this.stationId = this.station.value;
          }
        }

        if (!stationList) {
          this.station = this.stations[0];
          this.stationId = this.stations[0].value;
        }

        //find employee
        let employee;
        if (this.dataObj.assignedEmployeeId >= 0) {
          let emp = this.dataObj.employees.filter(
            (e) => e.employeeId == this.dataObj.assignedEmployeeId
          );
          employee = emp && emp.length > 0 ? emp[0] : null;
        }

        //add default value to team
        let teamList;
        if (this.teams && this.teams.length > 0) {
          if (employee && employee.teamId != null && employee.teamId >= 0) {
            teamList = this.teams.filter((t) => t.value == employee.teamId);
            if (teamList && teamList.length > 0) {
              this.team = teamList[0];
              this.teamId = this.team.value;
            }
          }
        }

        if (!this.teams || this.teams.length == 0 || !teamList) {
          this.team = this.teams[0];
          this.teamId = this.teams[0].value;
        }

        //if (employee) {
        //  this.employee = employee[0];
        //  this.selection = [];
        //  this.selection.push(employee[0]);
        //  this.calculateCost(this.isMultiple);
        //  this.$forceUpdate();
        //}

        //if (this.dataObj.employeeId >= 0) {
        //  //load employee
        //  let employee = this.dataObj.employees.filter(e => e.employeeId == this.dataObj.employeeId);
        //  if (employee && employee.length > 0) {
        //    this.employee = employee[0];
        //    this.selection = [];
        //    this.selection.push(this.employee);
        //    this.calculateCost(this.isMultiple);
        //    this.$forceUpdate();
        //  }
        //}
      });
    },
    resetDropDowns(type = "all") {
      if (type == "all")
        this.team = this.teams && this.teams.length > 0 ? this.allTeams[0] : {};

      this.selection = [];
      this.employee = {};
    },
    calculateCost(multiple) {
      let total = 0;

      //error traps
      if (
        parseInt(this.manpower.workDuration) < 0 ||
        isNaN(parseInt(this.manpower.workDuration))
      ) {
        this.manpower.workDuration = 0;
        return;
      }
      if (
        parseInt(this.manpower.travelDuration) < 0 ||
        isNaN(parseInt(this.manpower.travelDuration))
      ) {
        this.manpower.travelDuration = 0;
        return;
      }
      if (this.selection == null || this.selection.length < 1) return;

      //calculate cost
      this.dataObj.selection = [];
      this.selection.forEach((p) => {
        this.dataObj.selection.push({
          id: p.employeeId,
          rate:
            p.rateHours != null ? p.rateHours[this.manpower.rateTypeId] : "",
          name: p.displayString,
        });
      });

      this.dataObj.selection.forEach((p) => {
        var singleCost =
          (this.manpower.workDuration * parseFloat(p.rate)) / 60 +
          (this.manpower.travelDuration * parseFloat(p.rate)) / 60;
        total =
          total + (p.minimumCharge > singleCost ? p.minimumCharge : singleCost);
      });

      //console.log("data selection", this.dataObj.selection);

      this.manpower.totalCost = total.toFixed(2);
    },
    setSelectedEmployee(value) {
      this.manpower.employee = this.employees.filter(
        (p) => p.employeeId === value
      )[0].displayString;
    },
    setSelectedAllowance(value) {
      this.manpower.allowance = this.allowances.filter(
        (p) => p.value === value
      )[0].text;
    },
    setSelectedRateType(value) {
      this.manpower.rateType = this.rateTypes.filter(
        (p) => p.value === value
      )[0].text;
    },

    employeesSelected(items) {
      this.selection = items;
    },
  },
};
